import { useState, ReactNode, useCallback, useRef, useEffect } from 'react';
import { driverObj } from './driverConfig';
import { TourContext } from './tourUtils';

const TOUR_PROCESSING_DELAY = 300;

export function TourProvider({ children }: { children: ReactNode }) {
    const [hasSeenTour, setHasSeenTour] = useState(() => {
        return localStorage.getItem('hasSeenTour') === 'true';
    });
    
    const [isTourActive, setIsTourActive] = useState(false);
    const [currentTourStep, setCurrentTourStep] = useState(0);
    const [isProcessingTour, setIsProcessingTour] = useState(false);
    const timeoutRef = useRef<number | null>(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const startTour = useCallback(() => {
        if (isProcessingTour) return;
      
        setIsProcessingTour(true);
        if (driverObj.isActive()) {
            driverObj.destroy();
        }
        setIsTourActive(true);
        setCurrentTourStep(0);
        
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
            setIsProcessingTour(false);
        }, TOUR_PROCESSING_DELAY);
    }, [isProcessingTour]);

    const endTour = useCallback(() => {
        setIsTourActive(false);
        localStorage.setItem('hasSeenTour', 'true');
        setHasSeenTour(true);
        if (driverObj.isActive()) {
            driverObj.destroy();
        }
    }, []);

    const resetTour = useCallback(() => {
        if (isProcessingTour) return;
        
        setIsProcessingTour(true);
        setIsTourActive(false);
        setHasSeenTour(false);
        localStorage.removeItem('hasSeenTour');
        localStorage.removeItem('hasSeenWelcomeModal');
        setCurrentTourStep(0);
        
        if (driverObj.isActive()) {
            driverObj.destroy();
        }
        
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
            setIsProcessingTour(false);
        }, TOUR_PROCESSING_DELAY);
    }, [isProcessingTour]);

    return (
        <TourContext.Provider value={{ 
            isTourActive, 
            startTour, 
            endTour, 
            resetTour, 
            hasSeenTour,
            currentTourStep,
            setCurrentTourStep 
        }}>
            {children}
        </TourContext.Provider>
    );
}